import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React, { useState } from 'react';
import { ANALYTICS_SUBJECT_ID_CANCEL_APPLY_PROMOTION_MODAL } from '../../../../../../analytics/Events';
import { ANALYTICS_MODAL_APPLY_PROMOTIONS } from '../../../../../../analytics/Sources';
import ModalDialog from '../../../../../common/ModalDialog';
import ApplyPromotionSuccessView from './ApplyPromotionSuccessView';
import ApplyPromotionViewContainer from './ApplyPromotionView';
const ApplyPromotionModal = props => {
  const [appliedPromotionDetails, setAppliedPromotionDetails] = useState();
  const onAppliedPromotionDetails = details => {
    setAppliedPromotionDetails(details);
  };
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onCloseModal = () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_CANCEL_APPLY_PROMOTION_MODAL
    });
    props.onCloseModal();
  };
  return /*#__PURE__*/React.createElement(ModalDialog, {
    width: "large",
    analyticsName: ANALYTICS_MODAL_APPLY_PROMOTIONS,
    heading: appliedPromotionDetails ? 'Promotion Applied Successfully' : 'Apply Promotion Code',
    onClose: onCloseModal
  }, appliedPromotionDetails ? /*#__PURE__*/React.createElement(ApplyPromotionSuccessView, {
    appliedPromotionDetails: appliedPromotionDetails,
    onCloseModal: promotionName => props.onCloseModal(promotionName)
  }) : /*#__PURE__*/React.createElement(ApplyPromotionViewContainer, {
    onAppliedPromotionDetails: onAppliedPromotionDetails,
    productName: props.productName,
    cloudId: props.cloudId,
    onCloseModal: onCloseModal,
    appIcon: props.appIcon
  }));
};
export default ApplyPromotionModal;